
import React, { useState } from "react";
import Logo from "../../assest/Arch-logo.png";
import {
  FaBuilding,
  FaClock,
  FaMoneyBillWave,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

// Translation dictionary
const translations = {
  gb: {
    // English
    searchPlaceholder: "Job title or company",
    location: "Location",
    allLocations: "All Locations",
    category: "Category",
    jobType: "Job Type",
    experienceLevel: "Experience Level",
    datePosted: "Date Posted",
    salary: "Salary",
    applyFilter: "Apply",
    details: "Details",
    apply: "Apply",
    categoryOptions: [
      "Construction",
      "Equipment Rental",
      "Manpower Supply",
      "Transportation",
      "IT & GPS Solutions",
    ],
    jobTypeOptions: ["Full time", "Part time", "Freelance", "Seasonal", "Fixed-term"],
    experienceOptions: ["No-experience", "Fresher", "Intermediate", "Expert"],
    dateOptions: ["Last Hour", "Last 24 Hours", "Last 7 Days", "Last 30 Days"],
    sar0: "SAR 0",
    sar20000: "SAR 20,000",
    description: "Description",
    close: "Close",
    applyNow: "Apply Now",
  },
  sa: {
    // Arabic
    searchPlaceholder: "عنوان الوظيفة أو الشركة",
    location: "الموقع",
    allLocations: "جميع المواقع",
    category: "الفئة",
    jobType: "نوع الوظيفة",
    experienceLevel: "مستوى الخبرة",
    datePosted: "تاريخ النشر",
    salary: "الراتب",
    applyFilter: "تطبيق",
    details: "التفاصيل",
    apply: "تقدم",
    categoryOptions: [
      "إنشاءات",
      "تأجير معدات",
      "توفير عمالة",
      "نقل",
      "حلول تكنولوجيا المعلومات ونظام تحديد المواقع",
    ],
    jobTypeOptions: ["دوام كامل", "دوام جزئي", "عمل حر", "موسمي", "محدد المدة"],
    experienceOptions: ["بدون خبرة", "مبتدئ", "متوسط", "خبير"],
    dateOptions: ["آخر ساعة", "آخر 24 ساعة", "آخر 7 أيام", "آخر 30 يومًا"],
    sar0: "0 ريال سعودي",
    sar20000: "20,000 ريال سعودي",
    description: "الوصف",
    close: "إغلاق",
    applyNow: "تقدم الآن",
  },
  fr: {
    // French
    searchPlaceholder: "Intitulé du poste ou entreprise",
    location: "Localisation",
    allLocations: "Tous les lieux",
    category: "Catégorie",
    jobType: "Type d'emploi",
    experienceLevel: "Niveau d'expérience",
    datePosted: "Date de publication",
    salary: "Salaire",
    applyFilter: "Appliquer",
    details: "Détails",
    apply: "Postuler",
    categoryOptions: [
      "Construction",
      "Location d'équipement",
      "Fourniture de main-d'œuvre",
      "Transport",
      "Solutions informatiques et GPS",
    ],
    jobTypeOptions: ["Temps plein", "Temps partiel", "Freelance", "Saisonnier", "Durée déterminée"],
    experienceOptions: ["Pas d'expérience", "Débutant", "Intermédiaire", "Expert"],
    dateOptions: ["Dernière heure", "Dernières 24 heures", "7 derniers jours", "30 derniers jours"],
    sar0: "0 SAR",
    sar20000: "20 000 SAR",
    description: "Description",
    close: "Fermer",
    applyNow: "Postuler maintenant",
  },
  de: {
    // German
    searchPlaceholder: "Stellenbezeichnung oder Unternehmen",
    location: "Standort",
    allLocations: "Alle Standorte",
    category: "Kategorie",
    jobType: "Anstellungsart",
    experienceLevel: "Erfahrungsniveau",
    datePosted: "Veröffentlichungsdatum",
    salary: "Gehalt",
    applyFilter: "Anwenden",
    details: "Einzelheiten",
    apply: "Bewerben",
    categoryOptions: [
      "Bauwesen",
      "Gerätevermietung",
      "Arbeitskräftebereitstellung",
      "Transport",
      "IT- und GPS-Lösungen",
    ],
    jobTypeOptions: ["Vollzeit", "Teilzeit", "Freiberuflich", "Saisonbedingt", "Befristet"],
    experienceOptions: ["Keine Erfahrung", "Anfänger", "Mittelstufe", "Experte"],
    dateOptions: ["Letzte Stunde", "Letzte 24 Stunden", "Letzte 7 Tage", "Letzte 30 Tage"],
    sar0: "0 SAR",
    sar20000: "20.000 SAR",
    description: "Beschreibung",
    close: "Schließen",
    applyNow: "Jetzt bewerben",
  },
};

const jobTranslations = {
  gb: {
    // English job titles and descriptions remain as is
  },
  sa: {
    // Arabic translations for job titles and descriptions
    "Project Manager": "مدير مشروع",
    "Civil Engineer": "مهندس مدني",
    "Heavy Equipment Operator": "مشغل معدات ثقيلة",
    "Safety Officer": "مسؤول سلامة",
    "IT Solutions Specialist": "أخصائي حلول تكنولوجيا المعلومات",
    "Transport Coordinator": "منسق نقل",
    "Oversee construction projects, manage teams, and ensure timely delivery within budget. Requires 5+ years of experience in project management.":
      "الإشراف على مشاريع البناء، وإدارة الفرق، وضمان التسليم في الوقت المحدد وفي حدود الميزانية. يتطلب 5+ سنوات من الخبرة في إدارة المشاريع.",
    "Design and supervise infrastructure projects. Must have a degree in Civil Engineering and 3+ years of experience.":
      "تصميم والإشراف على مشاريع البنية التحتية. يجب أن يكون لديك درجة في الهندسة المدنية و3+ سنوات من الخبرة.",
    "Operate heavy machinery such as bulldozers and cranes. Valid operator license required.":
      "تشغيل الآلات الثقيلة مثل الجرافات والرافعات. يلزم وجود رخصة مشغل سارية المفعول.",
    "Ensure compliance with safety regulations on construction sites. NEBOSH certification preferred.":
      "ضمان الامتثال للوائح السلامة في مواقع البناء. يفضل الحصول على شهادة NEBOSH.",
    "Develop and maintain IT solutions, including GPS systems. Requires expertise in software development.":
      "تطوير وصيانة حلول تكنولوجيا المعلومات، بما في ذلك أنظمة تحديد المواقع. يتطلب خبرة في تطوير البرمجيات.",
    "Coordinate logistics and transportation schedules. Strong organizational skills required.":
      "تنسيق جداول اللوجستيات والنقل. يلزم وجود مهارات تنظيمية قوية.",
  },
  fr: {
    // French translations for job titles and descriptions
    "Project Manager": "Chef de projet",
    "Civil Engineer": "Ingénieur civil",
    "Heavy Equipment Operator": "Opérateur d'équipement lourd",
    "Safety Officer": "Agent de sécurité",
    "IT Solutions Specialist": "Spécialiste des solutions informatiques",
    "Transport Coordinator": "Coordinateur de transport",
    "Oversee construction projects, manage teams, and ensure timely delivery within budget. Requires 5+ years of experience in project management.":
      "Superviser des projets de construction, gérer des équipes et assurer une livraison rapide dans les limites du budget. Nécessite 5 ans ou plus d'expérience en gestion de projet.",
    "Design and supervise infrastructure projects. Must have a degree in Civil Engineering and 3+ years of experience.":
      "Concevoir et superviser des projets d'infrastructure. Doit avoir un diplôme en génie civil et 3 ans ou plus d'expérience.",
    "Operate heavy machinery such as bulldozers and cranes. Valid operator license required.":
      "Utiliser des machines lourdes telles que des bulldozers et des grues. Licence d'opérateur valide requise.",
    "Ensure compliance with safety regulations on construction sites. NEBOSH certification preferred.":
      "Veiller au respect des règles de sécurité sur les chantiers de construction. Certification NEBOSH préférée.",
    "Develop and maintain IT solutions, including GPS systems. Requires expertise in software development.":
      "Développer et maintenir des solutions informatiques, y compris des systèmes GPS. Nécessite une expertise en développement de logiciels.",
    "Coordinate logistics and transportation schedules. Strong organizational skills required.":
      "Coordonner les horaires de logistique et de transport. De solides compétences organisationnelles sont requises.",
  },
  de: {
    // German translations for job titles and descriptions
    "Project Manager": "Projektmanager",
    "Civil Engineer": "Bauingenieur",
    "Heavy Equipment Operator": "Baggerführer",
    "Safety Officer": "Sicherheitsbeauftragter",
    "IT Solutions Specialist": "IT-Lösungsspezialist",
    "Transport Coordinator": "Transportkoordinator",
    "Oversee construction projects, manage teams, and ensure timely delivery within budget. Requires 5+ years of experience in project management.":
      "Bauprojekte überwachen, Teams führen und termingerechte Lieferung innerhalb des Budgets sicherstellen. Erfordert 5+ Jahre Erfahrung im Projektmanagement.",
    "Design and supervise infrastructure projects. Must have a degree in Civil Engineering and 3+ years of experience.":
      "Infrastrukturprojekte entwerfen und überwachen. Muss einen Abschluss in Bauingenieurwesen und 3+ Jahre Erfahrung haben.",
    "Operate heavy machinery such as bulldozers and cranes. Valid operator license required.":
      "Bedienen Sie schwere Maschinen wie Bulldozer und Kräne. Gültige Bedienerlizenz erforderlich.",
    "Ensure compliance with safety regulations on construction sites. NEBOSH certification preferred.":
      "Einhaltung der Sicherheitsvorschriften auf Baustellen sicherstellen. NEBOSH-Zertifizierung bevorzugt.",
    "Develop and maintain IT solutions, including GPS systems. Requires expertise in software development.":
      "Entwickeln und warten Sie IT-Lösungen, einschließlich GPS-Systemen. Erfordert Expertise in der Softwareentwicklung.",
    "Coordinate logistics and transportation schedules. Strong organizational skills required.":
      "Koordination von Logistik- und Transportplänen. Gute organisatorische Fähigkeiten erforderlich.",
  },
};

const CareersPage = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb; // Default to English if language not found
  const jobT = jobTranslations[language] || jobTranslations.gb;
  
  const navigate = useNavigate();
  const careers = [
    {
      id: 1,
      title: jobT["Project Manager"] || "Project Manager",
      location: "Riyadh, KSA",
      type: t.jobTypeOptions[0], // Full time
      category: t.categoryOptions[0], // Construction
      salary: "SAR 15,000-SAR 20,000",
      company: "Etihad Gharbia Contracting Co.",
      description: jobT["Oversee construction projects, manage teams, and ensure timely delivery within budget. Requires 5+ years of experience in project management."] || 
        "Oversee construction projects, manage teams, and ensure timely delivery within budget. Requires 5+ years of experience in project management.",
    },
    {
      id: 2,
      title: jobT["Civil Engineer"] || "Civil Engineer",
      location: "Jeddah, KSA",
      type: t.jobTypeOptions[0], // Full time
      category: t.categoryOptions[0], // Construction
      salary: "SAR 10,000-SAR 14,000",
      company: "Etihad Gharbia Contracting Co.",
      description: jobT["Design and supervise infrastructure projects. Must have a degree in Civil Engineering and 3+ years of experience."] || 
        "Design and supervise infrastructure projects. Must have a degree in Civil Engineering and 3+ years of experience.",
    },
    {
      id: 3,
      title: jobT["Heavy Equipment Operator"] || "Heavy Equipment Operator",
      location: "Dammam, KSA",
      type: t.jobTypeOptions[0], // Full time
      category: t.categoryOptions[1], // Equipment Rental
      salary: "SAR 5,000-SAR 7,000",
      company: "Etihad Gharbia Contracting Co.",
      description: jobT["Operate heavy machinery such as bulldozers and cranes. Valid operator license required."] || 
        "Operate heavy machinery such as bulldozers and cranes. Valid operator license required.",
    },
    {
      id: 4,
      title: jobT["Safety Officer"] || "Safety Officer",
      location: "Riyadh, KSA",
      type: t.jobTypeOptions[0], // Full time
      category: t.categoryOptions[0], // Construction
      salary: "SAR 8,000-SAR 10,000",
      company: "Etihad Gharbia Contracting Co.",
      description: jobT["Ensure compliance with safety regulations on construction sites. NEBOSH certification preferred."] || 
        "Ensure compliance with safety regulations on construction sites. NEBOSH certification preferred.",
    },
    {
      id: 5,
      title: jobT["IT Solutions Specialist"] || "IT Solutions Specialist",
      location: "Riyadh, KSA",
      type: t.jobTypeOptions[0], // Full time
      category: t.categoryOptions[4], // IT & GPS Solutions
      salary: "SAR 12,000-SAR 15,000",
      company: "Etihad Gharbia Contracting Co.",
      description: jobT["Develop and maintain IT solutions, including GPS systems. Requires expertise in software development."] || 
        "Develop and maintain IT solutions, including GPS systems. Requires expertise in software development.",
    },
    {
      id: 6,
      title: jobT["Transport Coordinator"] || "Transport Coordinator",
      location: "Jeddah, KSA",
      type: t.jobTypeOptions[0], // Full time
      category: t.categoryOptions[3], // Transportation
      salary: "SAR 6,000-SAR 8,000",
      company: "Etihad Gharbia Contracting Co.",
      description: jobT["Coordinate logistics and transportation schedules. Strong organizational skills required."] || 
        "Coordinate logistics and transportation schedules. Strong organizational skills required.",
    },
  ];

  const [filter, setFilter] = useState({
    location: "",
    type: "",
  });
  const [selectedJob, setSelectedJob] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleFilterChange = (e) => {
    setFilter({ ...filter, [e.target.name]: e.target.value });
  };

  const handleShowDetails = (job) => {
    setSelectedJob(job);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedJob(null);
  };

  const filteredCareers = careers.filter((job) => {
    return (
      (filter.location === "" || job.location === filter.location) &&
      (filter.type === "" || job.type === filter.type)
    );
  });

  return (
    <div className="container-fluid my-4">
      <div className="row">
        {/* Sidebar Filter */}
        <aside className="col-md-3">
          <div className="bg-white p-3 rounded border">
            <h6 className="fw-bold mb-3">{t.searchPlaceholder}</h6>
            <input
              type="text"
              className="form-control mb-3"
              placeholder={t.searchPlaceholder}
            />

            <div className="mb-3">
              <label className="form-label fw-bold d-flex align-items-center">
                <FaMapMarkerAlt className="me-2 text-danger" /> {t.location}
              </label>
              <select
                name="location"
                className="form-select"
                value={filter.location}
                onChange={handleFilterChange}
              >
                <option value="">{t.allLocations}</option>
                <option value="Riyadh, KSA">Riyadh</option>
                <option value="Jeddah, KSA">Jeddah</option>
                <option value="Dammam, KSA">Dammam</option>
              </select>
            </div>

            <div className="mb-3">
              <p className="fw-bold mb-1">{t.category}</p>
              {t.categoryOptions.map((cat, idx) => (
                <div key={idx} className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`cat-${idx}`}
                    style={{ accentColor: "#dc3545" }}
                  />
                  <label className="form-check-label" htmlFor={`cat-${idx}`}>
                    {cat}
                  </label>
                </div>
              ))}
            </div>

            <div className="mb-3">
              <p className="fw-bold mb-1">{t.jobType}</p>
              {t.jobTypeOptions.map((type, idx) => (
                <div key={idx} className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`type-${idx}`}
                    style={{ accentColor: "#dc3545" }}
                  />
                  <label className="form-check-label" htmlFor={`type-${idx}`}>
                    {type}
                  </label>
                </div>
              ))}
            </div>

            <div className="mb-3">
              <p className="fw-bold mb-1">{t.experienceLevel}</p>
              {t.experienceOptions.map((level, idx) => (
                <div key={idx} className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="experience"
                    id={`exp-${idx}`}
                    style={{ accentColor: "#dc3545" }}
                  />
                  <label className="form-check-label" htmlFor={`exp-${idx}`}>
                    {level}
                  </label>
                </div>
              ))}
            </div>

            <div className="mb-3">
              <p className="fw-bold mb-1">{t.datePosted}</p>
              {t.dateOptions.map((time, idx) => (
                <div key={idx} className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="datePosted"
                    id={`date-${idx}`}
                    style={{ accentColor: "#dc3545" }}
                  />
                  <label className="form-check-label" htmlFor={`date-${idx}`}>
                    {time}
                  </label>
                </div>
              ))}
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">{t.salary}</label>
              <input type="range" className="form-range" />
              <div className="d-flex text-danger justify-content-between small">
                <span>{t.sar0}</span>
                <span>{t.sar20000}</span>
              </div>
              <button className="btn btn-danger w-100 mt-2">{t.applyFilter}</button>
            </div>
          </div>
        </aside>

        {/* Job Listings */}
        <main className="col-md-9">
          {filteredCareers.map((job) => (
            <div key={job.id} className="card mb-3 shadow-sm rounded-4">
              <div className="card-body d-flex flex-wrap justify-content-between align-items-center">
                <div className="d-flex align-items-start">
                  <img src={Logo} alt="logo" style={{ width: "40px" }} />

                  <div className="ms-2">
                    <h5 className="mb-1">{job.title}</h5>
                    <small className="text-muted">{job.company}</small>
                    <div className="d-flex flex-wrap mt-2 gap-3 text-muted small">
                      <div className="d-flex align-items-center gap-1 text-danger">
                        <FaBuilding /> {job.category}
                      </div>
                      <div className="d-flex align-items-center gap-1 text-danger">
                        <FaClock /> {job.type}
                      </div>
                      <div className="d-flex align-items-center gap-1 text-danger">
                        <FaMoneyBillWave /> {job.salary}
                      </div>
                      <div className="d-flex align-items-center gap-1 text-danger">
                        <FaMapMarkerAlt /> {job.location}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex gap-2 mt-3 mt-md-0">
                  <button
                    className="btn btn-outline-secondary rounded-5"
                    onClick={() => handleShowDetails(job)}
                  >
                    {t.details}
                  </button>
                  <button
                    className="btn btn-danger rounded-5"
                    onClick={() => navigate("/job-details", { state: { job } })}
                  >
                    {t.apply}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </main>
      </div>

      {/* Modal for Job Details */}
      {selectedJob && (
        <Modal show={showModal} onHide={handleCloseModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>{selectedJob.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex align-items-center mb-3">
              <img src={Logo} alt="logo" style={{ width: "50px" }} />
              <div className="ms-3">
                <h6>{selectedJob.company}</h6>
                <small className="text-muted">{selectedJob.location}</small>
              </div>
            </div>
            <p>
              <strong>{t.category}:</strong> {selectedJob.category}
            </p>
            <p>
              <strong>{t.jobType}:</strong> {selectedJob.type}
            </p>
            <p>
              <strong>{t.salary}:</strong> {selectedJob.salary}
            </p>
            <p>
              <strong>{t.description}:</strong> {selectedJob.description}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              {t.close}
            </Button>
            <Button variant="danger" onClick={() => navigate("/job-info", { state: { job: selectedJob } })}>
              {t.applyNow}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default CareersPage;
